import { observable } from "mobx";
import { ISkillScore } from "./opportunity";
import { Demographics } from "./profile";
import { ApplicationProcess} from "./enums";

export default class Application {
  @observable opId: string;
  @observable firstName: string;
  @observable lastName: string;
  @observable emailAddress: string;
  @observable phone: string;
  @observable statement: string;
  @observable scores: Array<ISkillScore>;
  @observable score: number;
  @observable appProcess: ApplicationProcess;

  constructor() {
    this.firstName = this.lastName = this.emailAddress = this.phone = this.statement = "";
    this.score = 0;
    this.scores = new Array<ISkillScore>();
    this.appProcess = ApplicationProcess.Unspecified;
  }
  mapFromProfile(demo: Demographics) {
    this.firstName = demo.firstName;
    this.lastName = demo.lastName;
    this.emailAddress = demo.emailAddress;
    this.phone = demo.phone;
  }
}


// WEBPACK FOOTER //
// ./src/models/application.ts